import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setWorksheetTitle } from "../../../worksheetSlice";
import CloseButton from "../../../../../components/CloseButton";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 설명 추가 — 학생에게 보이는 이름임을 안내
 * 2. 반응형 (고정 300px → max-width 460px)
 * 3. Enter로 다음 이동, 빈 제목 검증
 */
const TitleSelectionPage = ({ onClose, onClickNext }) => {
  const dispatch = useDispatch();
  const { worksheet } = useSelector((state) => state.worksheet);
  const [title, setTitle] = useState(worksheet.title);

  const handleNext = () => {
    if (!title.trim()) return alert("과제 제목을 입력해주세요.");
    dispatch(setWorksheetTitle(title));
    onClickNext();
  };

  return (
    <div
      
      style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "calc(80vh - 62px)", overflow: "hidden" }}
    >
      <CloseButton onClick={onClose} />

      <div style={{ padding: "26px 22px 8px" }}>
        <div className="ws-modal-title">과제 제목 설정</div>
        <p className="ws-modal-sub" style={{ marginBottom: "18px" }}>
          학생 화면에 보여질 이름입니다.
        </p>

        <input
          type="text"
          placeholder="과제 제목을 입력해주세요."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleNext()}
          autoFocus
          style={{
            fontSize: "0.95rem",
            width: "100%",
            padding: "13px 16px",
            border: "1.5px solid #E6EDEC",
            borderRadius: "12px",
            boxSizing: "border-box",
            fontFamily: "inherit",
            letterSpacing: "-0.01em",
            outline: "none",
            transition: "border-color .12s",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#00D9C0")}
          onBlur={(e) => (e.target.style.borderColor = "#E6EDEC")}
        />
      </div>

      <div className="ws-bottom-bar" style={{ marginTop: "26px" }}>
        <button className="ws-btn-next" onClick={handleNext}>
          다음
        </button>
      </div>
    </div>
  );
};

export default TitleSelectionPage;
